module.exports = "<div *ngFor=\"let content of contributorList\">\n    <a href=\"#\" class=\"listPageListHyperlinkItems\">\n        {{content}}\n        <!-- {{content.contentTitle}} | {{content.contentSubTitle}} -->\n    </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/v1ComponentInfo/v1ComponentInfo.component.html
// module id = ../../../../../src/app/components/v1ComponentInfo/v1ComponentInfo.component.html
// module chunks = main